// @flow
import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import { colors, modalStyles } from '../../shared/styles';

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const StyledOrderDetailModal = styled(ReactModal)`
    width: 680px;
    margin: 40px auto 0 auto;
    background: ${colors.white};
    border-radius: 4px;

    & .title {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .title h3 {
        margin: 0;
    }

    & .actions {
        text-align: right;
        padding: 10px;
        border-top: 1px solid ${colors.offWhite};
    }

    & .actions button {
        padding: 5px 10px;
        border: 0;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
    }

    & .actions .primary {
        background: ${colors.orange.default};
        color: ${colors.white};
    }

    & .content {
        min-height: 200px;
        background: #edf1f2;
        overflow-y: scroll;
        max-height: calc(100vh - 200px);
    }

    & .content-wrapper {
        padding: 20px 20px 20px 20px;
    }

    & .content img {
        max-width: 100%;
    }

    & .content .row {
        display: flex;
        padding-bottom: 10px;
    }

    & .content .col {
        flex: 1;
    }

    & .content .col p {
        margin: 0 20px 10px 0;
    }

    & h4 {
        margin: 0;
        font-weight: 700;
    }

    & img {
        padding-bottom: 20px;
    }

    & a {
        color: #000;
    }
`;

const OrderDetailModal = (props: any) => {
    const { board, onCancel, isOpen, labels } = props;

    let boardData = null;

    if (board && labels) {
        boardData = {
            reference: board.property.propertyReference,
            name: board.property.propertyName,
            address: board.property.propertyAddress,
            town: board.property.propertyTown,
            postCode: board.property.propertyPostCode,
            instruction: labels.instructions[board.toLetBoardInstruction],
            type: labels.type[board.toLetBoardBoardType],
            additionalWording: board.toLetBoardAdditionalWording,
            placement: labels.placement[board.toLetBoardPlacement],
            fixingInstructions: board.toLetBoardFixingInstructions,
            keyRequired: board.toLetBoardKeyRequire === true ? 'Yes' : 'No',
            keyRequireText:
                board.toLetBoardKeyRequire === true
                    ? board.toLetBoardKeyRequireText
                    : null,
            location: {},
            locationDescription: board.toLetBoardLocationDescription,
            photo: board.photo,
            staticMapImgUrl: `https://maps.googleapis.com/maps/api/staticmap?center=${board.toLetBoardLat},${board.toLetBoardLong}&zoom=16&size=680x300&maptype=roadmap&markers=${board.toLetBoardLat},${board.toLetBoardLong}&scale=2&key=${apiKey}`,
            contacts: board.property.contacts,
        };
    }

    return (
        <StyledOrderDetailModal
            contentLabel="To Let Board Order Details"
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={200}
            isOpen={isOpen}
            style={modalStyles}
        >
            <div className="title">
                <h3>To Let Board Order Details</h3>
            </div>

            {boardData &&
                <div className="content">
                    <div className="content-wrapper">
                        <div className="row">
                            <div className="col">
                                <h4>Reference:</h4>
                                <p>
                                    {boardData.reference}
                                </p>
                                <h4>Name:</h4>
                                <p>
                                    {boardData.name}
                                </p>
                                <h4>Address:</h4>
                                <p>
                                    {boardData.address}
                                    {boardData.town
                                        ? `, ${boardData.town}`
                                        : ''}
                                    {boardData.postCode
                                        ? `, ${boardData.postCode}`
                                        : ''}
                                </p>
                                <h4>Contact:</h4>
                                {boardData.contacts &&
                                    boardData.contacts.map((contact, index) => {
                                        return (
                                            <p key={contact.contactId}>
                                                {contact.contactForenames}{' '}
                                                {contact.contactSurname}
                                                {contact.contactTelephone
                                                    ? `, ${contact.contactTelephone}`
                                                    : ''}
                                                {contact.contactEmail &&
                                                    <span>
                                                        <br />
                                                        <a
                                                            href={`mailto:${contact.contactEmail}`}
                                                        >
                                                            {
                                                                contact.contactEmail
                                                            }
                                                        </a>
                                                    </span>}
                                            </p>
                                        );
                                    })}
                            </div>

                            <div className="col">
                                <h4>Instruction:</h4>
                                <p>
                                    {boardData.instruction}
                                </p>
                                <h4>Board Type:</h4>
                                <p>
                                    {boardData.type}
                                </p>
                                <h4>Additional Wording:</h4>
                                <p>
                                    {boardData.additionalWording}
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <h4>Board Placement:</h4>{' '}
                                <p>{boardData.placement}</p>
                                <h4>Fixing Instructions:</h4>{' '}
                                <p>{boardData.fixingInstructions}</p>
                            </div>

                            <div className="col">
                                <h4>Key Required:</h4>
                                <p>
                                    {boardData.keyRequired}
                                </p>

                                {boardData.keyRequireText &&
                                    <span>
                                        <h4>Additional Details:</h4>{' '}
                                        <p>{boardData.keyRequireText}</p>
                                    </span>}
                            </div>
                        </div>

                        <div>
                            <img
                                src={boardData.staticMapImgUrl}
                                alt="Location"
                            />
                        </div>

                        <div className="row">
                            <div className="col">
                                <h4>Location Description:</h4>{' '}
                                <p>{boardData.locationDescription}</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                {!boardData.photo &&
                                    <span>
                                        <h4>Photo:</h4> <p>Not Specified</p>
                                    </span>}
                            </div>
                        </div>

                        <div>
                            {boardData.photo &&
                                <img
                                    src={boardData.photo.url}
                                    alt="Guidance"
                                />}
                        </div>
                    </div>
                </div>}

            <div className="actions">
                <button className="primary" onClick={onCancel}>
                    Close
                </button>
            </div>
        </StyledOrderDetailModal>
    );
};

export default OrderDetailModal;



// WEBPACK FOOTER //
// ./src/components/ToLetBoards/OrderDetailModal.js